import { useActivityBuilderContext } from 'approot/activity-builder/activity-builder.context';
import { ComponentEmptyButton } from '../shared/component-parts';
import { EditProps } from '../link/link.constants';
import WebToolView from './webtool-view';

const WebToolEdit = (props: EditProps) => {
  const { openDrawer } = useActivityBuilderContext();

  return props.stimulusResourceProperties ? (
    <WebToolView {...props} />
  ) : (
    <>
      <ComponentEmptyButton
        iconId="web-tool"
        onClick={() => openDrawer({ componentId: props.id })}
        buttonText="Add Web Tool"
        isSmall
      />
    </>
  );
};

export default WebToolEdit;
